// import request from '@/utils/request'

import { getToken } from '@/utils/auth'

export function export_data(entity, type = 'csv') {

  return fetch(
    process.env.VUE_APP_BASE_API + `/export/${type}/${entity}`,
    {
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      responseType: 'blob'     
    }
  )
  .then( response => {
    
    const filename = response.headers.get("X-Filename")

    response.blob().then( blob => {
      var fileURL = window.URL.createObjectURL(blob);
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    })
  })
  
}
